// extracted by mini-css-extract-plugin
export default {"fields":"DBk_yx","time":"my362_","mobile":"n4rXqy"};